let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cV2OA")).then(() => parcelRequire('c66Q0'));